import React, { useState, useEffect } from 'react';
import work2 from './../assets/work2.png';
import work3 from './../assets/work3.png';
import work4 from './../assets/work4.png';
import work5 from './../assets/work5.png';
import work6 from './../assets/work6.png';
import work7 from './../assets/work7.png';
import './Portfolio.css'; 

export function Portfolio() {
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    { src: work2, caption: "Fan Art :)" },
    { src: work3, caption: "Cookie the Bomber" },
    { src: work4, caption: "Tank Goes Burrrrrrrr" },
    { src: work5, caption: "Average Factory" },
    { src: work6, caption: "Cookie in Space" },
    { src: work7, caption: "Cookie in War" }
  ];

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); 

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="carousel">
      <div className="note">
        This is some of my artwork, reflecting my projects and creativity! I'm inspired about the people and world around me, for instance, Cookie, my friend's Laura's cat, is the muse of many of my pieces :)
      </div>
      <button className="carousel-arrow left-arrow" onClick={handlePrev}>
        &#8592;
      </button>
      {images.map((image, index) => (
        <div
          key={index}
          className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
          style={{ display: index === activeIndex ? 'block' : 'none' }}
        >
          <img src={image.src} alt={`carousel-${index}`} className="carousel-image" /> 
          <div className="caption">{image.caption}</div>
        </div>
      ))}
      <button className="carousel-arrow right-arrow" onClick={handleNext}>
        &#8594;
      </button>
    </div>
  );
}